import { request } from '@umijs/max';
import { safeLoginRedirect } from '@/pages/user/login/feishuAuth';

export const CHANGE_PASSWORD_PATH = '/user/change-password';

export interface PasswordPolicy {
  minLength: number;
  maxBytes: number;
  description: string;
  requireCurrentPassword: boolean;
}

export function getPasswordPolicy() {
  return request<{ success: boolean; data: PasswordPolicy }>(
    '/api/crm/admin/auth/password-policy',
    { skipErrorHandler: true },
  );
}

export function changePassword(values: {
  currentPassword?: string;
  newPassword: string;
  confirmPassword: string;
}) {
  return request<{ success: boolean }>(
    '/api/crm/admin/auth/change-password',
    { data: values, skipErrorHandler: true },
  );
}

export function loginDestination(mustChangePassword: boolean, redirect: string | null) {
  const destination = safeLoginRedirect(redirect);
  return mustChangePassword
    ? `${CHANGE_PASSWORD_PATH}?redirect=${encodeURIComponent(destination)}`
    : destination;
}
